(function () {

    function loadScript(src) {
        return new Promise(function (resolve) {
            var s = document.createElement('script');
            s.src = src;
            s.async = true;
            s.onload = resolve;
            document.head.appendChild(s);
        });
    }

    function loadGA4() {
        if (window.gaLoaded) return;
        window.gaLoaded = true;

        loadScript("https://www.googletagmanager.com/gtag/js?id=G-PSZLLK3KGL")
            .then(function () {
                window.dataLayer = window.dataLayer || [];
                function gtag() { dataLayer.push(arguments); }
                window.gtag = gtag;
                gtag('js', new Date());
                gtag('config', 'G-PSZLLK3KGL');
                console.log('GA4 loaded');
            });
    }

    function loadGTM() {
        if (window.gtmLoaded) return;
        window.gtmLoaded = true;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'gtm.js',
            'gtm.start': new Date().getTime()
        });

        var s = document.createElement('script');
        s.async = true;
        s.src = "https://www.googletagmanager.com/gtm.js?id=GTM-5Q3DMNF3";
        document.head.appendChild(s);
    }

    function loadKlaviyo() {
        if (window.klaviyoLoaded) return;
        window.klaviyoLoaded = true;

        window._learnq = window._learnq || [];

        var s = document.createElement('script');
        s.async = true;
        s.src = "https://static.klaviyo.com/onsite/js/X362dY/klaviyo.js?company_id=X362dY";
        document.head.appendChild(s);

        console.log('Klaviyo loaded');
    }

    function checkConsent() {

        if (!window.Pandectes) return;

        var consent = window.Pandectes.consent;

        if (!consent) return;

        if (consent.analytics) {
            loadGA4();
        }

        if (consent.marketing) {
            loadGTM();
            loadKlaviyo();
        }
    }

    setTimeout(checkConsent, 2000);

    document.addEventListener('pandectes:consent', checkConsent);

})();